import PropTypes from "prop-types";
import cn from "classnames";
import Container from "solar/components/Container";
import styles from "components/stay/Section.module.scss";

export default function Section({
  children,
  contained = false,
  padded = false,
}) {
  return contained ? (
    <Container>{children}</Container>
  ) : (
    <div className={cn(padded ? styles.padded : styles.default)}>
      {children}
    </div>
  );
}

Section.propTypes = {
  children: PropTypes.node.isRequired,
  padded: PropTypes.bool,
  contained: PropTypes.bool,
};
